import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { MainHeader, Breadcrumb, MainFooter, ImageElement } from "../../components";

function Howitworks() {
    const breadcrumb = [
        {
            path: '/Home',
            name: 'Home',
        },
        {
            path: '#',
            name: 'How It Works',
        },
    ];
    return (
        <>       
            <MainHeader/>
            <main className="aboutPage">
                <Container>
                    <Breadcrumb title="How It Works" breadcrumb={breadcrumb}/>
                    <div className="aboutPage_inner">
                        <h2 className="aboutPage_title mt-0">All jobs booked via the App include:</h2>
                        <ul className="list-unstyled">
                            <li>Service by a local Good Guys company in your area (We do not sub out to random come and go subcontractors.)<br/>All technicians have a minimum of 5 years of field experience</li>
                            <li>Friendly Customer Service</li>
                            <li>Flat Rate Pricing (No Hidden Fees)</li>
                            <li>Warranty on all work completed</li>
                            <li>Goods Guys Satisfaction Guarantee</li>
                            <li>A commitment to match you with the same technician every time in the future</li>
                        </ul>  
                        <p>Good Guys Home Services is the premier service provider app for your home. The “joys” of homeownership can be a burden sometimes. Our purpose is to make those “joys” a little less stressful. With live real-time scheduling features and the ability to request immediate emergency service, we are changing the experience forever.</p>
                        <div className="aboutPage_steps">
                            <Row className="g-lg-0 g-2 justify-content-center">
                                <Col md="6" lg="4">
                                    <div className="aboutPage_steps_box">
                                        <div className="text-center">
                                            <ImageElement source="step-1.svg" className="img-fluid"/>
                                        </div>
                                        <p>Download the App, pick the type of service you need and then decide if you want same day service or schedule in the future.</p>
                                    </div>
                                </Col>
                                <Col md="6" lg="4">
                                    <div className="aboutPage_steps_box">
                                        <div className="text-center">
                                            <ImageElement source="step-2.svg" className="img-fluid"/>
                                        </div>
                                        <p>Once you select your appointment, you will receive confirmation of your appointment and the technician will confirm when they are heading to your home.</p>
                                    </div>
                                </Col>
                                <Col md="6" lg="4">
                                    <div className="aboutPage_steps_box">
                                        <div className="text-center">
                                            <ImageElement source="step-3.svg" className="img-fluid"/>
                                        </div>
                                        <p>We will diagnose the problem and provide you with options for repairs. Once you authorize the repair, we will get to work. When we are completed, we can accept payment and your house can get back to being home again!</p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <p>Our team is comprised of all top tier background-checked technicians with over 5 years’ experience in the field. Utilizing our App will connect you directly to a Good Guy to help get your home and life back to normal. Once you’re connected with a Good Guy, you can always request that same technician every time via the App. Regardless of which technician visits your home, we respect your house by wearing floor savers, utilizing drop cloths and cleaning up when we are done.</p>
                        <p>Have a question about something in your home. Use our FREE chat in the App to “Ask The Expert”. Based on the type of question you have, you will be connected directly to an expert in that field that can help answer some questions.</p>
                        <p>Download our Good Guys Home Services App today and find the right technician for your home today.</p>
                        <h2 className="aboutPage_title">Good Guys Home Services Features:</h2>
                        <div className="focuSec">
                            <Row>
                                <Col md={4}>
                                    <div className="focuSec_box overflow-hidden">
                                        <div className="focuSec_head">
                                            <h3 className="text-uppercase">TOP TIER TECHNICIANS</h3>
                                        </div>
                                        <div className="focuSec_body">
                                            <ul className="mb-0 list-unstyled">
                                                <li>Over 5 years’ experience in the field</li>
                                                <li>Good Guy Satisfaction Guaranteed</li>
                                                <li>Read reviews on your specific technician before they arrive to your home</li>
                                            </ul>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="focuSec_box overflow-hidden">
                                        <div className="focuSec_head">
                                            <h3 className="text-uppercase">SCHEDULING OPTIONS</h3>
                                        </div>
                                        <div className="focuSec_body">
                                            <ul className="mb-0 list-unstyled">
                                                <li>Same day emergency service</li>
                                                <li>Pick your day and time frame that works best for you</li>
                                                <li>See upcoming appointments</li>
                                                <li>Maintains a history of the work completed via Good Guys Home Services App</li>
                                            </ul>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="focuSec_box overflow-hidden">
                                        <div className="focuSec_head">
                                            <h3 className="text-uppercase">PAYMENT OPTIONS</h3>
                                        </div>
                                        <div className="focuSec_body">
                                            <ul className="mb-0 list-unstyled">
                                                <li>Credit Card</li>
                                                <li>Check</li>
                                                <li>Apply for financing</li>
                                            </ul>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="focuSec_box overflow-hidden">
                                        <div className="focuSec_head">
                                            <h3 className="text-uppercase">HOME SERVICES PROVIDED</h3>
                                        </div>
                                        <div className="focuSec_body">
                                            <ul className="mb-0 list-unstyled">
                                                <li>HVAC</li>
                                                <li>Plumbing</li>
                                                <li>Electrical</li>
                                                <li>Handyman</li>
                                            </ul>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="focuSec_box overflow-hidden">
                                        <div className="focuSec_head">
                                            <h3 className="text-uppercase">HOMEOWNER TIP OF THE MONTH</h3>
                                        </div>
                                        <div className="focuSec_body">
                                            <ul className="mb-0 list-unstyled">
                                                <li>Helpful tips or specials to help save you time and money around your home</li>
                                            </ul>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="focuSec_box overflow-hidden">
                                        <div className="focuSec_head">
                                            <h3 className="text-uppercase">ASK THE EXPERT</h3>
                                        </div>
                                        <div className="focuSec_body">
                                            <ul className="mb-0 list-unstyled">
                                                <li>Have a question? Ask The Expert through our online chat in the App</li>
                                            </ul>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>  
                    </div>
                </Container>
            </main>
            <MainFooter/>
        </>
    );
  }
  
  export default Howitworks;